import SelectAreaComponent from './index.vue'
let $vm
let _resolve
let _reject

(function () {
  function install (Vue) {
    const SelectArea = Vue.extend(SelectAreaComponent)
    let selectArea = () => {
      if (!$vm) {
        $vm = new SelectArea({
          el: document.createElement('div')
        })
        document.body.appendChild($vm.$el)
      }
      //clearVm($vm)
      $vm.$on('on-cancel', function() {
        $vm.show=false
        _resolve(null)
      });
      $vm.$on('on-confirm', function(data) {
        $vm.show=false
        _resolve(data)
      });
      setTimeout(() => {
        $vm.show = true
      }, 0)
      return new Promise((resolve,reject) => {
        _resolve = resolve
        _reject = reject
      })
    }
    Vue.mixin({
      created: function () {
        this.$selectArea = selectArea
      }
    })
  }

  if (typeof exports == "object") {
    module.exports = install
  } else if (typeof define == "function" && define.amd) {
    define([], function(){ return install })
  } else if (window.Vue) {
    Vue.use(install)
  }

})()



// WEBPACK FOOTER //
// ./static/plugins/select-area/index.js